(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cookie-banner"] && !Shopify.designMode) return;
  try {
    (function () {
  var banner = document.getElementById('cookie-banner');
  if (!banner) return;

  var views = {
    intro: banner.querySelector('[data-view="intro"]'),
    prefs: banner.querySelector('[data-view="prefs"]')
  };
  var toggles = banner.querySelectorAll('.ckb__toggle');

  function show() { banner.hidden = false; }
  function hide() { banner.hidden = true; }
  function setView(name) {
    views.intro.hidden = name !== 'intro';
    views.prefs.hidden = name !== 'prefs';
  }

  function consentFrom(analytics, marketing) {
    return {
      analytics: analytics,
      preferences: analytics,
      marketing: marketing,
      sale_of_data: marketing
    };
  }

  var STORAGE_KEY = 'ckb-consent';
  var REMEMBER_DAYS = 180;

  function remember() {
    try { localStorage.setItem(STORAGE_KEY, String(Date.now())); } catch (e) {}
  }
  function hasAnswered() {
    try {
      var t = parseInt(localStorage.getItem(STORAGE_KEY), 10);
      if (!t) return false;
      return (Date.now() - t) < REMEMBER_DAYS * 86400000;
    } catch (e) { return false; }
  }

  function apply(consent) {
    var api = window.Shopify && window.Shopify.customerPrivacy;
    if (!api) { hide(); return; }
    api.setTrackingConsent(consent, function (data) {
      if (data && data.error) { return; }
      remember();
      hide();
    });
  }

  banner.addEventListener('click', function (e) {
    var action = e.target.getAttribute('data-ckb');
    if (!action) return;
    if (action === 'accept') apply(consentFrom(true, true));
    else if (action === 'reject') apply(consentFrom(false, false));
    else if (action === 'customize') setView('prefs');
    else if (action === 'back') setView('intro');
    else if (action === 'save') {
      var picked = { analytics: false, marketing: false };
      toggles.forEach(function (t) { picked[t.getAttribute('data-cat')] = t.checked; });
      apply(consentFrom(picked.analytics, picked.marketing));
    }
  });

  function openManager() {
    var api = window.Shopify && window.Shopify.customerPrivacy;
    if (api) {
      var current = api.currentVisitorConsent ? api.currentVisitorConsent() : {};
      toggles.forEach(function (t) {
        t.checked = current[t.getAttribute('data-cat')] === 'yes';
      });
    }
    setView('prefs');
    show();
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-cookie-settings]');
    if (trigger) { e.preventDefault(); openManager(); }
  });

  function alreadyDecided(api) {
    if (!api || typeof api.currentVisitorConsent !== 'function') return false;
    var c = api.currentVisitorConsent() || {};
    return [c.analytics, c.marketing, c.preferences, c.sale_of_data].some(function (v) {
      return v === 'yes' || v === 'no';
    });
  }

  function init() {
    if (hasAnswered()) { return; }
    var api = window.Shopify && window.Shopify.customerPrivacy;
    // Shopify's own banner is removed, so shouldShowBanner() no longer drives this.
    // Respect a consent decision already recorded by Shopify (e.g. at checkout);
    // otherwise show our branded banner until the visitor answers.
    if (alreadyDecided(api)) { remember(); return; }
    setView('intro');
    show();
  }

  if (window.Shopify && window.Shopify.loadFeatures) {
    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (error) { if (!error) init(); }
    );
  }
})();
  } catch(e) { console.error(e); }
})();

})();
